import React, { useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './index.scss';
import { FormBuilder, IFORM } from 'featureLib/FormBuilder';
import { REFER_BUSINESS } from './referFormConfig';
import { trackMOEEvent } from 'common/services/moengage.service';
import { MOENGAGE_ANALYTICS_EVENT } from 'common/constants/app.constants';
import { faOnDedicatedReferBusinessSubmit } from 'dedicated/services/analytics.service';
import { facebookSmbLead, googleOrderPixel, removeFromSessionStorage, scrollToTop, setInSessionStorage } from 'common/utils/app.utils';
import { createSiebelLead, submitExpert } from 'common/helper/api.helper';
import { AUTHORIZATION_HEADER, MODULE_ID } from 'home/common/constants/constants';

let disableAll: any;
const ReferBusiness = (props: any) => {
  const { setshowsubmitSuccess } = props;
  const isdedicatedJourney = true;
  const [disabled, setDisabled] = useState(true);
  const [payload, setPayload] = useState({
    email: '',
    companyName: '',
    customerName: '',
    phoneNumber: '',
    leadSource: 'REFER_A_BUSINESS'
  });

  const sendReferBusinessDetail = (payload: any) => {
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.THANK_YOU_PAGE_REFER_A_BUSINESS, { ...payload });
    faOnDedicatedReferBusinessSubmit(payload);
    googleOrderPixel();
    facebookSmbLead('Refer');
    submitExpert(payload, isdedicatedJourney)
      .then((res) => {
        if (res.data.success) {
          let auth_token = res && res.headers && res.headers.authorization_token;
          if (auth_token) {
            setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
          }
          createSiebelLead(isdedicatedJourney).then((res) => {
            if (res && res.data && res.data.success) {
              setshowsubmitSuccess(true);
              scrollToTop();
              clearState();
              removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
              setTimeout(() => {
                setshowsubmitSuccess(false);
              }, 5000);
            }
          });
          // .catch(err => console.error(err));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const clearState = () => {
    disableAll();
  };

  const onSubmit = (form: { isValid: boolean; values: IFORM; disabelAll: any; clearAll: any }) => {
    disableAll = form?.clearAll;
    setDisabled(!form.isValid);
    if (form.isValid) {
      let payload = {
        email: form?.values?.emailAddress?.value,
        companyName: form?.values?.companyName?.value,
        customerName: form?.values?.customerName?.value,
        phoneNumber: form?.values?.phoneNumber?.value,
        leadSource: 'REFER_A_BUSINESS'
      };
      setPayload(payload);
    }
  };

  const onReferSubmit = () => {
    sendReferBusinessDetail(payload);
  };

  return (
    <div className="refer_business">
      <div className="card-section">
        <h4>Refer a business</h4>
        <div className="accordion-content">
          <div className="row">
            <FormBuilder formConfig={REFER_BUSINESS} onSubmit={onSubmit} onChange={() => {}}></FormBuilder>
            <div className="flg-lg-12 flg-md-12">
              <div className="next-button">
                <Button onClick={onReferSubmit} disabled={disabled} displayName="Submit" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferBusiness;
